<template>
  <v-flex v-if="entityId != null && entryId != null">
    <v-flex my-4>
      <label class="upload">
        Fișier:
        <input
          id="file"
          ref="file"
          type="file"
          multiple
          class="choose-file-ro show-content"
          @change="onFileSelect"
        />
      </label>
      <v-btn
        color="yellow"
        :disabled="file == null || file === ''"
        @click="onUpload"
        >Încarcă</v-btn
      >
    </v-flex>
    <ReactiveDynamicForm
      :key="updates"
      v-model="formValue"
      :schema="attachmentSchema"
      @indexChange="rowClick"
      @iconClicked="iconClick"
    ></ReactiveDynamicForm>
  </v-flex>
</template>

<script>
import ApiService from '../APIService'

export default {
  name: 'AttachmentsWidget',
  components: {
    ReactiveDynamicForm: () => import('../ReactiveDynamicForm')
  },
  props: {
    entityId: {
      type: String,
      required: true
    },
    entryId: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // :initialValue="formValue"
      translateFileLabel: true,
      formValue: this.value,
      updates: 0,
      file: '',
      clicks: 0,
      attachmentSchema: {
        table: {
          type: 'table',
          headers: [
            {
              text: 'Nume fișier',
              value: 'fileName'
            },
            {
              text: 'Dimensiune fișier',
              value: 'fileSizeInBytes'
            }
          ],
          rows: []
        }
      }
    }
  },
  mounted() {
    this.refreshAttachments()
  },
  methods: {
    print() {
      // console.log("ATTACHMENT" + JSON.stringify(this.value));
    },
    onFileSelect() {
      this.file = this.$refs.file.files
      document.getElementById('file').className = 'choose-file-ro hide-content'
    },
    onUpload() {
      for (var i = 0; i < this.file.length; i++) {
        let formData = new FormData()
        formData.append('file', this.file[i])

        ApiService.uploadAttachment(this.entityId, this.entryId, formData)
          .then((res) => {
            if (res < 200 && res.status > 299)
              console.log('Could not upload attachment: ' + res.statusText)
            else {
              this.file = ''
              this.refreshAttachments()
            }
          })
          .catch((error) => {
            console.log('Could not upload attachment: ' + JSON.stringify(error))
          })
      }
    },
    refreshAttachments() {
      ApiService.getAllAttachments(this.entityId, this.entryId)
        .then((res) => {
          res = res.data
          res.forEach((row) => {
            if (row.fileSizeInBytes != null)
              row.fileSizeInBytes = this.formatBytes(row.fileSizeInBytes, 2)
          })
          this.attachmentSchema.table.rows = res
        })
        .catch((error) => {
          console.log('Error', error)
        })
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    forceFileDownload(response, downloadFileName) {
      // console.log("Download file name: " + downloadFileName);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { encoding: 'UTF-8' })
      )
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', downloadFileName)
      document.body.appendChild(link)
      link.click()
    },
    iconClick(value) {
      this.clicks = 1
      if (confirm('Sunteti sigur ca vreti sa continuati aceasta operatiune?')) {
        ApiService.deleteAttachments(value[0]._id)
          .then((res) => {
            if (res < 200 && res.status > 299)
              console.log('Could not delete attachment: ' + res.statusText)
            else {
              this.file = ''
              this.refreshAttachments()
            }
          })
          .catch((error) => {
            console.log('Could not delete attachment: ' + JSON.stringify(error))
          })
      }
    },
    rowClick(value) {
      if (this.clicks === 0) {
        console.log(JSON.stringify(value[0]))
        ApiService.downloadAttachment(value[0]._id)
          .then((res) => {
            console.log(
              '%cAttachment downloaded: ' + JSON.stringify(res.data),
              'color: #0f0'
            )
            this.forceFileDownload(res, value[0].fileName)
          })
          .catch((error) => {
            console.log('%cCould not download attachment: ', 'color: #f00')
            console.log(JSON.stringify(error))
          })
        this.$emit('inputChange', value)
      }
      this.clicks = 0
    }
  }
}
</script>

<style scoped>
.upload {
  margin-left: 1.7%;
}
.choose-file-ro::-webkit-file-upload-button {
  visibility: hidden;
}
.choose-file-ro::after {
  margin-left: -6em;
  background: white;
}
.choose-file-ro::before {
  content: 'Alege fișier';
  display: inline-block;
  background: #f5f5f5;
  border: 1px solid #999;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  text-shadow: 1px 1px #fff;
  font-weight: 400;
  font-size: 1em;
}
.choose-file-ro:hover::before {
  border-color: rgb(27, 27, 27);
}
.choose-file-ro:active::before {
  background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}
.show-content {
  content: 'Niciun fișier ales';
}
.hide-content {
  content: '';
}
</style>
